/** One shared import for foreground/background callers; rejected loads can retry. */
export function createRetryableLoader<T>(load: () => Promise<T>) {
  let pending: Promise<T> | undefined;
  let prepared: T | undefined;
  const loadOnce = () => {
    if (!pending) {
      pending = load()
        .then((value) => {
          prepared = value;
          return value;
        })
        .catch((error: unknown) => {
          pending = undefined;
          throw error;
        });
    }
    return pending;
  };
  loadOnce.peek = () => prepared;
  return loadOnce;
}
